export default __webpack_public_path__ + "static/media/celikes5.1540c5dd.jpg";